import { Directive, HostListener, ElementRef, Output, EventEmitter } from "@angular/core";

@Directive({
    selector: '[date]'
})

export class DateDirective {

    @Output() valueChange = new EventEmitter();
    @Output() validate = new EventEmitter();

    constructor(private el: ElementRef) {
    }

    @HostListener('keyup', ['$event']) keyup(event: KeyboardEvent) {
        var reg1 = /^[<|>|=](\s+)?(([0-9])|([0-2][0-9])|([3][0-1]))\-(Jan|jan|Feb|feb|Mar|mar|Apr|apr|May|may|Jun|jun|Jul|jul|Aug|aug|Sep|sep|Oct|oct|Nov|nov|Dec|dec)\-\d{4}$/;
        var reg2 = /^(([0-9])|([0-2][0-9])|([3][0-1]))\-(Jan|jan|Feb|feb|Mar|mar|Apr|apr|May|may|Jun|jun|Jul|jul|Aug|aug|Sep|sep|Oct|oct|Nov|nov|Dec|dec)\-\d{4}$/;
        let current: string = this.el.nativeElement.value;
        if (current.toLowerCase()) {
            if (!reg1.test(current.toLowerCase()) && !reg2.test(current.toLowerCase()))
                this.validate.emit(true);
            else
                this.validate.emit(false);
        }
        else {
            this.validate.emit(false);
        }
    }

    @HostListener('input') onInput() {
        this.valueChange.emit(this.dateModel);
    }

    get dateModel(): any {
        var _elmValue = this.el.nativeElement.value;
        var _operator = _elmValue.charAt(0);
        switch (_operator) {
            case "<":
            case ">":
            case "=": {
                var _value = _elmValue.substr(1, _elmValue.length);
                break;
            }
            default: {
                var _value = _elmValue.replace(/\,/g, '');
                _operator = "=";
                break;
            }
        }
        return { value: _value.trim(), sign: _operator }
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/el-data-management/eldm-filters/date-validate-directive.ts